import { maxImageZoom } from "@brickme/project-core/src/model/picture.ts";
import { pixAPicKit } from "@brickme/project-core/src/pix-a-pic.ts";
import { maxLayoutDimension } from "~/features/editor/layout-permutations.ts";

const maxResolution =
	pixAPicKit.basePlateSize * maxLayoutDimension * maxImageZoom;

export { maxResolution };
